import { render, staticRenderFns } from "./storetype.vue?vue&type=template&id=f6f302a0&scoped=true&"
import script from "./storetype.vue?vue&type=script&lang=js&"
export * from "./storetype.vue?vue&type=script&lang=js&"
import style0 from "./storetype.vue?vue&type=style&index=0&id=f6f302a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f302a0",
  null
  
)

export default component.exports